module.exports = __webpack_public_path__ + "img/Group.94cc49aa.png";